import React, { useEffect } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import "./css/custom.css";
import "./css/events.css";
import "./css/font.css";
import Navbar from "./components/template/Navbar";

import Footer from "./components/template/Footer";
//import PopularCategories from "./components/PopularCategories";
//import PopularLocations from "./components/PopularLocations";
//import Divider from "./components/Divider";
import SearchListing from "./components/common/SearchListing";
import BodyContent from "./components/body/BodyContent";
import { BrowserRouter as Router, Switch, Route, useLocation } from "react-router-dom"; //It is for Live Server
// import { HashRouter as Router, Switch, Route, useLocation } from "react-router-dom"; // It is for Beta Server
import DetailWindow from "./components/common/DetailWindow";
// import Loader from "./components/common/Loader";
import Contact from "./components/pages/Contact";
import About from "./components/pages/About";
import Privacy from "./components/pages/Privacy";
import Terms from "./components/pages/Terms";
import { HelmetProvider } from "react-helmet-async";
import EventsIndex from "./components/events/EventsIndex";
import EventsSearch from "./components/events/EventsSearch";
import EventSuccess from "./components/events/EventSuccess";
import Eticket from "./components/pages/Eticket";
// import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";

import ScrollToTop from "./components/ScrollToTop";
import StripeProvider from "./components/providers/StripeProvider";
import { setSettings } from "./app/features/companySetting/companySettingSlice";
import { useDispatch } from "react-redux";
import EventRouter from "./router/EventRouter";
import { QueryClient, QueryClientProvider } from "react-query";

const AppContent = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  async function fetchSettings() {
    await axios
      .request({
        method: "GET",
        url: process.env.REACT_APP_BASE_URL + "/api/settings",
        headers: {
          Authorization: process.env.REACT_APP_API_KEY,
        },
      })
      .then(function (response) {
        dispatch(setSettings(response.data.data));
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  useEffect(() => {
    fetchSettings();
  }, []);
  const isOrganizerPage = /^\/events\/[^/]+$/.test(location.pathname);

  return (
    <StripeProvider>
      <div className="App min-vh-100">
        {/* ✅ Conditionally render Navbar */}
        {isOrganizerPage ? null : <Navbar />}

        {/* <AuthModal /> */}
        {/* <AppModal /> */}
        <ScrollToTop />
        <Switch>
          <Route exact path="/">
            <BodyContent pageTitle={"Home"} metaTitle="Exquisite Nepalese House Services: Bringing the Essence of Nepal to Your UK Home" metaContent="Our Nepalese Mechanics and services  are not only experts in their field but also uphold the values of trust, integrity, and respect. Rest assured that your property is in safe hands, as we treat every project as if it were our own." />
          </Route>

          <Route exact path="/events">
            <EventsIndex pageTitle={"Events"} />
          </Route>

          {/* <Route exact path="/counter">
              <Counter pageTitle={"Counter"} />
          </Route> */}

          <Route exact path="/search">
            <SearchListing page="list" />
          </Route>

          <Route exact path="/business/:id">
            <DetailWindow pageTitle={"Business Detail"} />
          </Route>

          <Route exact path="/property/:id">
            <DetailWindow pageTitle={"Property Detail"} />
          </Route>

          <Route exact path="/job/:id">
            <DetailWindow pageTitle={"Job Detail"} />
          </Route>

          <Route exact path="/events/:slug">
            <EventRouter />
          </Route>

          <Route exact path="/ticket/:id">
            <EventSuccess pageTitle={"Event Ticket"} />
          </Route>

          <Route exact path="/contact">
            <Contact pageTitle={"Contact Us"} />
          </Route>

          <Route exact path="/about">
            <About pageTitle={"About Us"} />
          </Route>

          <Route exact path="/privacy">
            <Privacy pageTitle={"Privacy Policy"} />
          </Route>

          <Route exact path="/terms">
            <Terms pageTitle={"Terms & Conditions"} />
          </Route>

          <Route exact path="/e-ticket">
            <Eticket pageTitle={"E-Ticket"} />
          </Route>

          <Route exact path="/events/search">
            <EventsSearch pageTitle={"Events Search"} />
          </Route>
        </Switch>
      </div>

      {isOrganizerPage ? null : <Footer />}
    </StripeProvider>
  );
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      retry: function (failureCount, error) {
        if (error && error.response && error.response.status === 429) {
          return failureCount < 3;
        }
        return failureCount < 2;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    },
  },
});

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <Router>
          <AppContent />
        </Router>
      </HelmetProvider>
    </QueryClientProvider>
  );
};

export default App;
